module.exports = __webpack_public_path__ + "media/images/basic_logos/edit-orange-391c82ae90459d5e07f30173a7679197.svg";